import { createFileRoute } from "@tanstack/react-router"
import { lazyImportRouteComponent } from "../../../../utils/lazyImportRouteComponent"

type SearchParams = {
  phone?: string
}

export const Route = createFileRoute("/app/contacts/call/")({
  component: lazyImportRouteComponent(
    () => import("./-components/call-page"),
    "SupportCallPage"
  ),
  validateSearch: (search: SearchParams) => search,
})
